import { backgroundGreen, black, orange } from '@/theme/colors'
import styled from 'styled-components'

export const TripCardContainer = styled.div`
	background: white;
	border: 1px solid #e1e5e9;
	border-radius: 12px;
	padding: 2rem 1.5rem;
	transition: all 0.2s ease;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	display: flex;
	flex-direction: column;
	gap: 1rem;
	height: 100%;
	min-height: 180px;
	cursor: pointer;
	justify-content: center;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		border-color: ${orange};
	}

	@media (max-width: 600px) {
		padding: 1.25rem 1rem;
		min-height: auto;
	}
`

export const TripCardHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	align-items: center;
	text-align: center;
`

export const TripTitle = styled.h3`
	margin: 0;
	font-size: 1.25rem;
	font-weight: 600;
	color: #2c3e50;
	line-height: 1.4;
	text-align: center;
`

export const TripCodeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: center;
`

export const TripCodeLabel = styled.span`
	font-size: 0.875rem;
	color: #6c757d;
	font-weight: 500;
`

export const TripCode = styled.span`
	background: ${backgroundGreen};
	color: ${black};
	padding: 0.25rem 0.75rem;
	border-radius: 6px;
	font-size: 0.875rem;
	font-weight: 700;
	font-family: 'Courier New', monospace;
`

export const TripMeta = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`

export const TripMetaItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	font-size: 0.875rem;
	color: #6c757d;
`

export const TripMetaLabel = styled.span`
	font-weight: 500;
`

export const TripMetaValue = styled.span`
	color: #495057;
`

export const TripDateRange = styled.div`
	font-size: 0.875rem;
	color: #6c757d;
	margin-top: 0.5rem;
`

export const TripDaysCount = styled.div`
	background: #e3f2fd;
	color: #1976d2;
	padding: 0.25rem 0.5rem;
	border-radius: 4px;
	font-size: 0.75rem;
	font-weight: 500;
	display: inline-block;
`

